import { PayloadAction } from '../../../store.model';
import { filterRows } from '../function/filter-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { ApplyFilterSelection } from './apply-filter-selection.action';

export function applyFilterSelectionReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.MI2_MAIN__APPLY_FILTER_SELECTION,
        ApplyFilterSelection
    >,
): MainState {
    try {
        const nextCurrPerfItems = [...state.currentPerformanceClassFilterItems];
        const nextPrevPerfItems = [
            ...state.previousPerformanceClassFilterItems,
        ];
        const nextImprovementItems = [...state.improvementGroupFilterItems];

        action.payload.selection?.forEach((item) => {
            const currPrefIndex = nextCurrPerfItems.findIndex(
                (e) => e.item === item.item,
            );
            if (currPrefIndex !== -1) {
                nextCurrPerfItems[currPrefIndex] = { ...item };
            }

            const prevPerfIndex = nextPrevPerfItems.findIndex(
                (e) => e.item === item.item,
            );
            if (prevPerfIndex !== -1) {
                nextPrevPerfItems[prevPerfIndex] = { ...item };
            }

            const improvementIndex = nextImprovementItems.findIndex(
                (e) => e.item === item.item,
            );
            if (improvementIndex !== -1) {
                nextImprovementItems[improvementIndex] = { ...item };
            }
        });

        const nextFilteredDirectReports = filterRows({
            rows: state.rows,
            sortOptions: state.sortOptions,
            currentPerformanceClassFilterItems: nextCurrPerfItems,
            previousPerformanceClassFilterItems: nextPrevPerfItems,
            improvementGroupFilterItems: nextImprovementItems,
        });

        return {
            ...state,
            filteredRows: nextFilteredDirectReports,
            currentPerformanceClassFilterItems: nextCurrPerfItems,
            previousPerformanceClassFilterItems: nextPrevPerfItems,
            improvementGroupFilterItems: nextImprovementItems,
        };
    } catch {
        return {
            ...state,
        };
    }
}
